import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../i18n/LanguageContext';
import { IconSymbol } from './ui/IconSymbol';

const FeaturesSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      id: 1,
      iconName: 'write-speak-scan',
      titleKey: 'features.feature1.title',
      descriptionKey: 'features.feature1.desc',
    },
    {
      id: 2,
      iconName: 'privacy-secure',
      titleKey: 'features.feature2.title',
      descriptionKey: 'features.feature2.desc',
    },
    {
      id: 3,
      iconName: 'pdf-export',
      titleKey: 'features.feature3.title',
      descriptionKey: 'features.feature3.desc',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="py-12 md:py-20 px-6 md:px-12 bg-light-bg">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
          className="text-center mb-16"
        >
          <h2 className="font-filson font-bold text-4xl md:text-5xl text-gray-900 mb-4">
            {t('features.title')}
          </h2>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {features.map((feature) => (
            <motion.div
              key={feature.id}
              variants={itemVariants}
              className="card"
              style={{
                borderRadius: '12px',
                border: '1px solid #E7EAE5',
                padding: '24px',
                backgroundColor: 'white',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
              }}
              whileHover={{
                y: -8,
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
              }}
            >
              {/* Icon */}
              <div
                style={{
                  marginBottom: '16px',
                  display: 'inline-block',
                }}
              >
                <IconSymbol
                  name={feature.iconName}
                  size={48}
                  color="#CB4B4B"
                />
              </div>

              {/* Title */}
              <h3 className="font-filson font-bold text-xl text-gray-900 mb-3">
                {t(feature.titleKey)}
              </h3>

              {/* Description */}
              <p className="font-filson font-medium text-base text-gray-600 leading-relaxed">
                {t(feature.descriptionKey)}
              </p>

              {/* Accent Line */}
              <div
                style={{
                  marginTop: '16px',
                  height: '3px',
                  width: '40px',
                  backgroundColor: '#d5b76d',
                  borderRadius: '2px',
                }}
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
